import { render, staticRenderFns } from "./merchantRegister.vue?vue&type=template&id=fc7fb428&scoped=true"
import script from "./merchantRegister.vue?vue&type=script&lang=js"
export * from "./merchantRegister.vue?vue&type=script&lang=js"
import style0 from "./merchantRegister.vue?vue&type=style&index=0&id=fc7fb428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7fb428",
  null
  
)

export default component.exports